import LegalLayout from "@/components/LegalLayout";
import { Button } from "@/components/ui/button";

export default function CookiePolicy() {
  const openPrefs = () => {
    window.dispatchEvent(new Event("biab:open-cookie-preferences"));
  };

  return (
    <LegalLayout
      testid="cookie-policy-page"
      title="Cookie Policy"
      lastUpdated="February 2026"
    >
      <p>
        This Cookie Policy explains how Brand-in-a-Box uses cookies and
        similar tracking technologies on our website. You can update your
        preferences at any time.
      </p>

      <div className="not-prose my-8">
        <Button
          data-testid="cookie-policy-manage-button"
          onClick={openPrefs}
          className="rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6"
        >
          Manage Cookie Preferences
        </Button>
      </div>

      <h2>What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you visit a
        website. They help websites function properly, remember preferences,
        and understand how users interact with content.
      </p>

      <h2>Categories of Cookies We Use</h2>

      <h3>Essential Cookies</h3>
      <p>
        Required for the website to function — for example, securing form
        submissions, remembering session data, and preserving your cookie
        preferences. These cookies cannot be disabled.
      </p>

      <h3>Analytics Cookies</h3>
      <p>
        Help us understand how visitors interact with the site so we can
        improve performance and content. Analytics cookies are only set if
        you grant consent.
      </p>

      <h3>Marketing Cookies</h3>
      <p>
        Used to deliver personalized advertising and measure campaign
        performance. Only set with your explicit consent.
      </p>

      <h3>Preference Cookies</h3>
      <p>
        Remember choices you've made (such as preferred language or display
        settings) so you don't need to re-enter them on every visit.
      </p>

      <h2>Managing Your Preferences</h2>
      <p>
        You can accept all cookies, reject non-essential cookies, or manage
        individual categories via our cookie banner. You can also clear or
        block cookies via your browser settings.
      </p>

      <h2>Third-Party Cookies</h2>
      <p>
        Some cookies may be set by third-party services we use (such as
        analytics or embedded media providers). These third parties have
        their own privacy and cookie policies.
      </p>

      <h2>Updates</h2>
      <p>
        We may update this policy as our practices change. The "Last updated"
        date will reflect any revisions.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about cookies?{" "}
        <a href="mailto:hello@bigeyedeassystems.com">hello@bigeyedeassystems.com</a>.
      </p>
    </LegalLayout>
  );
}
